import { render, staticRenderFns } from "./OrderCommentVisibleForCustomer.vue?vue&type=template&id=29f1ee19&"
import script from "./OrderCommentVisibleForCustomer.vue?vue&type=script&lang=ts&"
export * from "./OrderCommentVisibleForCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports